// import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import fontawesome from '@fortawesome/fontawesome';
import { window } from 'browser-monads';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/fontawesome-free-solid';
import { Link } from 'gatsby';
import { Location } from '@reach/router';
import { TimelineMax } from 'gsap';
import { Navigation } from '../Navigation';
import { ImageLazyLoad } from '../ImageLazyLoad';
import MenuIconImage from '../../assets/images/menu_icon.png';
import wrpLogo from '../../assets/images/wrplogo2d.png';

fontawesome.library.add(faBars);

const HeaderWrapper = styled.div`
  z-index: 10;
  /* overflow: hidden; */
  /* padding: 20px 10px; */
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  // position: relative;
  position: fixed;
  top: 0px;
  opacity: 1;
  width: 100vw;
  transition: top 0.6s;
  background-color: ${props => (props.mode === 'light' ? '#fff' : '#1c0a1c')};
  .centerPadding {
    padding-left: 40px;
  }
  a {
    /* color: white; */
    color: ${props => (props.mode === 'light' ? '#000' : '#fff')};
    text-align: center;
    padding: 12px;
    text-decoration: none;
    font-size: 0.9em;
    line-height: 25px;
    border-radius: 4px;
  }
  a.logo {
    font-family: AvenirBold;
    font-size: 1em;
    font-weight: 900;
    img {
      width: 70px;
      height: auto;
    }
    @media (max-width: 567px) {
      img {
        width: 55px;
      }
    }
  }
  &.hideHeader {
    top: -80px;
  }
`;
const MenuItemsWrapper = styled.div`
  width: 100%;
  text-align: center;
  font-weight: 900;
  font-size: 16px;
  position: relative;
  display: inline-flex;
  justify-content: center;
  // iPad styles
  @media (max-width: 991px) {
    display: none;
  }
`;
const MenuIcon = styled.div`
  float: right;
  cursor: pointer;
  color: ${props => (props.mode === 'light' ? '#000' : '#fff')} !important;
`;
const MenuItemStyle = styled.div`
  font-family: AvenirBold;
  color: ${props => (props.mode === 'light' ? '#000' : '#fff')};
  font-size: 16px;
  letter-spacing: 0.24px;
  position: relative;
`;
const MenuItemText = styled.div`
  padding: 0px 25px;
  text-transform: uppercase;
  letter-spacing: 3.89px;
  &:active {
    font-style: italic;
  }
`;
const MenuItemBorder = styled.div`
  z-index: -1;
  width: 0px;
  height: 31px;
  background: ${props => (props.mode === 'light' ? '#f2f1f2' : 'grey')};
  position: absolute;
  left: 20px;
  top: -3px;
`;

const NavIcon = styled.img`
  width: 24px;
  height: 24px;
  filter: ${props => (props.mode === 'dark' ? 'invert(0)' : 'invert(1)')};
`;

const NavigationButton = styled.div`
  display: block;

  @media (min-width: 992px) {
    display: none;
  }
`;

const ExternalLink = styled.a`
  text-decoration: none !important;
  :hover {
    color: inherit;
  }
`;

const menuItems = [
  // { link: "/", title: "Home" },
  { link: '/work', title: 'Work' },
  { link: 'https://sites.google.com/a/werplay.com/careers/', title: 'Careers' },
  { link: '/about', title: 'About' },
  { link: '/contact', title: 'Contact' }
];

const Header = ({ mode }) => {
  const childRef = useRef();
  const [prevScrollPos, setprevScrollPos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    var selectedAnimation = new TimelineMax();
    selectedAnimation.to('.selectedItem', 0.3, {
      width: '60px'
    });
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  });
  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const visilbeTemp =
      prevScrollPos > currentScrollPos || currentScrollPos < 100;

    setprevScrollPos(currentScrollPos);
    if (visilbeTemp !== visible) {
      setVisible(visilbeTemp);
    }
  };
  useEffect(() => {
    console.log(prevScrollPos, window.pageYOffset);
  }, [visible]);
  var showOrHideHeader = visible ? '' : 'hideHeader';
  return (
    <Location>
      {({ location }) => (
        <HeaderWrapper mode={mode} className={showOrHideHeader}>
          <div className='container'>
            <div className='row align-items-center'>
              <div className='col-8 col-md-2'>
                <Link to='/' className='logo'>
                  <img src={wrpLogo} />
                </Link>
              </div>
              <div className='col col-md-8 centerPadding'>
                <MenuItemsWrapper>
                  {menuItems.map((menuItem, index) => {
                    if (menuItem.title == 'Careers') {
                      return (
                        <MenuItemStyle mode={mode} key={index}>
                          <MenuItemText>
                            <ExternalLink
                              target='_blank'
                              href='https://sites.google.com/a/werplay.com/careers/'>
                              Careers
                            </ExternalLink>
                          </MenuItemText>
                        </MenuItemStyle>
                      );
                    } else {
                      return (
                        <MenuItemStyle mode={mode} key={index}>
                          <MenuItemText>
                            <Link
                              to={menuItem.link}
                              style={{
                                color: 'inherit',
                                textDecoration: `none`
                              }}>
                              {menuItem.title}
                            </Link>
                          </MenuItemText>
                          {(location.pathname === menuItem.link ||
                            location.pathname === menuItem.link + '/') && (
                            <MenuItemBorder
                              mode={mode}
                              className='selectedItem'
                            />
                          )}
                        </MenuItemStyle>
                      );
                    }
                  })}
                </MenuItemsWrapper>
              </div>
              <div className='col-1 col-md-2 d-block d-lg-none'>
                <MenuIcon>
                  <NavIcon
                    mode={mode}
                    src={MenuIconImage}
                    onClick={() => childRef.current.toggleNavigation()}
                  />
                  {/* onClick={clickNavigation} */}
                </MenuIcon>
              </div>
            </div>
          </div>
          <Navigation location={location.pathname} ref={childRef} />
        </HeaderWrapper>
      )}
    </Location>
  );
};

Header.propTypes = {
  sample: PropTypes.bool,
  bgColor: PropTypes.oneOf(['dark', 'light'])
};

Header.defaultProps = {
  sample: false,
  mode: 'light'
};

export { Header };
